<template>
  <div id="app">
    <div class="home" data-aos="fade-up">
      <div class="home-content">
        <h1>Streamline Your Care:</h1>
        <h2>
          Connecting <span class="highlight">Patients</span> and <span class="highlight">Doctors</span> Effortlessly
        </h2>
        <p>
          Effortlessly manage and update patient records with our system,
          designed exclusively for hospital staff. Ensure accurate and
          efficient care every step of the way.
        </p>
        <!-----<button class="get-started-button"  @click.prevent="$emit('open-popup')">Get started ➔</button>-->

      </div>  
      <img
        :src="require('@/assets/login and cloud.png')"
        alt="Home Image"
        class="home-image"
        data-aos="slide-in"
      />
    </div>

    <section id="features" class="section features" data-aos="fade-up">
      <div class="features-content">
        <img
          :src="require('@/assets/doc image.png')"
          alt="Doc Image"
          class="doc-image"
          data-aos="slide-in"
        />
        <div class="features-list">
          <h1>Our Features</h1>
          <p>• Centralized Data</p>
          <p>• Data Security</p>
          <p>• Real-time Updates</p>
          <p>• User-Friendly Interface</p>
          <p>• Seamless Integration</p>
        </div>
      </div>
    </section>

    <section id="add-patient" class="section add-patient" data-aos="fade-up" ref="addPatientSection">

      <div class="add-patient-content">
        <h1>Add patient</h1>
        <p>Quickly and easily add patient details to enhance personalized care.</p>
      </div>
      <img
        :src="require('@/assets/add patient.png')"
        alt="Add Patient"
        class="add-patient-image"
        data-aos="slide-in"
      />
    </section>

    <section class="section patient-details" data-aos="fade-up">
      <h1>
        Electronic Medical Records (EMR) management</h1>
      <p> Find all the medical records (prescriptions, reports, invoices etc) grouped 
        together sorted by date of digital record creation in the application.</p>
    </section>

    <section id="records" class="section records" data-aos="fade-up">
      <img
        :src="require('@/assets/records.png')"
        alt="Records Image"
        class="records-image"
        data-aos="slide-in"
      />
      <div class="patient-detail-container">
        <div class="patient-detail-text">
          <h1>Patient Details</h1>
          <p>Here are some details about the patient that may include medical history, current medications, and more.</p>
        </div>
        <img
          :src="require('@/assets/patient detail.png')"
          alt="Patient Detail Image"
          class="patient-detail-image"
          data-aos="slide-in"
        />
      </div>
    </section>

    <!---<section id="testimonials" class="section testimonials" data-aos="fade-up">
      <h1 class="feedback-heading">Feedback Section</h1>
      <div
        class="testimonial-slider"
        ref="testimonialSlider"
        @scroll="handleScroll"
      >
        <div
          class="testimonial-container"
          :style="{ width: `${totalWidth}px` }"
        >
          <div
            v-for="(testimonial, index) in extendedTestimonials"
            :key="index"
            class="testimonial-card"
          >
            <div class="testimonial-content">
              <img
                :src="require(`@/assets/${testimonial.image}`)"
                alt="Testimonial Image"
                class="testimonial-image"
              />
              <div class="testimonial-text">
                <span>- {{ testimonial.name }}</span>
                <p>"{{ testimonial.feedback }}"</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>-->
  </div>
</template>

<script>
export default {
  name: "EMR",
 /* data() {
    return {
      testimonials: [
        { image: 'testimonial1.png', name: 'Dr. Smith', feedback: 'This system has transformed how we manage patient records! Efficient and reliable.' },
        { image: 'testimonial2.png', name: 'Nurse Alice', feedback: 'Very intuitive and easy to use. Our team loves it!' },
        { image: 'testimonial3.png', name: 'Dr. Jones', feedback: 'Patient care has improved significantly thanks to this platform.' }
      ],
      totalWidth: 0, 
    };
  },
  computed: {
    extendedTestimonials() {
      return Array(30).fill(this.testimonials).flat();
    }
  },
  methods: {
    
    scrollToAddPatient() {
    const section = this.$refs.addPatientSection;
    section.scrollIntoView({ behavior: 'smooth' });
  },
},
  mounted() {
    this.$nextTick(() => {
      const cardWidth = this.$refs.testimonialSlider.children[0].offsetWidth;
      this.totalWidth = cardWidth * this.extendedTestimonials.length;
    });
  }*/
};
</script>

<style scoped>
.section {
  padding: 20px;
}

.home {
  background-color: black;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  flex-wrap: wrap;
}

.home-content {
  flex: 1;
  color: #fff;
  min-width: 300px;
  margin-left: 20px;
}

h1 {
  font-size: 3rem;
  margin-bottom: 10px;
}

h2 {
  font-size: 3rem;
  margin-bottom: 10px;
}

.highlight {
  color: #B5F6FF; 
}

p {
  font-size: 2rem;
  color: grey;
}

.features {
  background-color: black;
}

.features-content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 5px;
}

.features-list {
  color: white;
  font-size: 1.5rem;
  margin-left: 300px;
}

.doc-image {
  width: 550px;
  height: auto;
  border-radius: 10px;
  margin-left: 120px;
}

.add-patient {
  background-color: black;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  max-width: 100%;
  flex-wrap: wrap;
}

.add-patient-content {
  flex: 1;
  text-align: left;
  margin-bottom: 20px;
  margin-left: 250px; 
}

.add-patient-image {
  width: 100%;
  max-width: 550px;
  height: auto;
  margin-right: 150px;
}

.patient-details {
  color: white;
  font-size: 1.5rem;
  text-align: center;
  margin-top: 20px;
}

.records-image {
  display: block;
  margin: 20px auto; 
  width: 100%; 
  max-width: 750px; 
}

.patient-detail-container {
  display: flex; 
  justify-content: space-between; 
  align-items: center; 
  margin-top: 20px; 
}

.patient-detail-image {
  display: block;
  margin: 20px; 
  max-width: 550px; 
  width: 100%; 
  margin-right: 150px;
}

.patient-detail-text {
  color: white; 
  font-size: 1.5rem; 
  margin-right: 20px; 
  max-width: 400px; 
  margin-left: 250px;
}

.testimonials {
  background-color: black;
}

.home-image {
  width: 550px;
  height: auto;
  border-radius: 50px;
  margin-left: -20px;
}

.get-started-button {
  background-color: #0048A5;
  color: white;
  border: none; 
  border-radius: 5px; 
  padding: 10px 20px; 
  font-size: 1.5rem; 
  cursor: pointer; 
  transition: background-color 0.3s, transform 0.3s, box-shadow 0.3s; 
}

.get-started-button:hover {
  background-color: darkblue; 
  transform: scale(1.05); 
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2); 
}

.section {
  padding: 20px;
}

.testimonials {
  background-color: black;
  overflow: hidden;
}

.testimonial-slider {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  gap: 20px;
  padding: 20px 0;
  scrollbar-width: none; 
}


.testimonial-container {
  display: flex;
}

.testimonial-slider::-webkit-scrollbar {
  display: none;
}

.testimonial-card {
  flex: 0 0 550px;
  background-color: #141414;
  color: #fff;
  padding: 20px;
  border-radius: 10px;
  margin: 0 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.testimonial-content {
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  gap: 15px;
}

.testimonial-image {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.testimonial-text span {
  font-size: 1.5rem;
  font-weight: bold;
  color: #b5f6ff;
}

.testimonial-text p {
  font-size: 1.2rem;
}

.feedback-heading {
  text-align: center; 
  color: white; 
  font-size: 2rem; 
  margin-bottom: 20px; 
}

.arrow-button {
  background-color: transparent;
  color: white;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  margin: 0 20px;
  transition: transform 0.3s;
}

.arrow-button:hover {
  transform: scale(1.2);
}

.left-arrow {
  margin-right: auto; 
}

.right-arrow {
  margin-left: auto; 
}


/* Responsive styles */
@media (max-width: 850px) {
  .home {
    flex-direction: column;
    align-items: center;
  }

  .home-content {
    text-align: center; 
    max-width: 100%;
    margin-bottom: 20px;
  }

  .home-image,
  .doc-image,
  .add-patient-image,
  .patient-detail-image {
    width: 100%; 
    max-width: 400px; 
    margin: 0 auto; 
    display: block; 
  }

  .features-content {
    flex-direction: column-reverse;
    align-items: center;
  }

  .features-list {
    text-align: center; 
    margin-left: 0;
    font-size: 1.2rem;
    margin-bottom: 15px;
  }

  .add-patient {
    flex-direction: column;
    text-align: center; 
    padding: 10px;
  }

  .add-patient-content {
    margin-bottom: 10px;
    margin-left: 0; 
    text-align: center; 
  }

  .records-image {
    width: 100%; 
    max-width: 950px; 
    margin: 0 auto; 
  }

  .patient-detail-container {
    flex-direction: column; 
    text-align: center; 
  }

  .patient-detail-text {
    color: white; 
    font-size: 1.5rem; 
    margin-right: 0; 
    margin-left: 0; 
    margin-top: 10px;
    max-width: 100%; 
    text-align: center; 
  }

  .testimonial-card {
    flex: 0   0 250px;
  }

  h1 {
    font-size: 2rem;
    text-align: center; 
  }

  h2 {
    font-size: 1.5rem;
    text-align: center; 
  }

  p {
    font-size: 1.2rem;
    text-align: center; 
  }
}
</style>
